import axios from 'axios'

export default {
  install(app, options) {
    var apiDomain = options?.apiDomain || ''
    var region = options?.region || ''

    app.config.globalProperties.$eventsService = {
      /*
      * Get events from API using custom query params
      */
      async searchWithParams(params) {
        if (params) {
          params.region = region
        }                    
        
        return await axios.get(apiDomain + '/v1/events/search', { params: params })
      },

      /*
      * Get event details by Id
      */
      async getEventById(eventId) {
        return await this.searchWithParams({
          eventcampaignid: eventId,
        })
      }
    }
  }
}